import { Navigate } from "react-router-dom";

import { RoutePathEnum } from "@/routes/paths";
import { useUserStore } from "@/stores/use-user-store";
import { getUserInitialDepartmentRoute } from "@/utils/department-routes";

/**
 * Redireciona a rota (/:department) para a página de talentos do department do usuário.
 *
 * @remarks
 * **ATENÇÃO**: Este componente deve ser usado apenas em rotas autenticadas.
 * O componente assume que `activeUser` está disponível e não é null.
 *
 * @requires activeUser - Usuário autenticado no store
 * @see RootRedirect - Componente de proteção de rotas
 *
 * @example
 * ```tsx
 * <Route element={<RootRedirect />}>
 *   <Route path="/:department" element={<DepartmentRedirect />} />
 * </Route>
 * ```
 */
export function DepartmentRedirect() {
  const activeUser = useUserStore((state) => state.activeUser);

  if (!activeUser) {
    return <Navigate to={RoutePathEnum.LOGIN} replace />;
  }

  // Construir rota com department do usuário
  const targetPath = getUserInitialDepartmentRoute(activeUser);

  if (!targetPath) {
    return <Navigate to={RoutePathEnum.LOGIN} replace />;
  }

  return <Navigate to={targetPath} replace />;
}
